// Components
import { Spinner } from 'components/lib';
// I18n
import { t } from 'i18n';
// Styles
import styles from './appLoader.module.scss';

/**
 * The first load of the app (a reload, a sign-in): nothing is known yet, not even which pages the
 * user may open, so there is no page shape to draw. A spinner covers the whole window until the
 * user has loaded; inside the app the loading states are placeholders shaped like their content.
 */
const AppLoader = () => (
  <div role="status" data-cy="app-loader" className={styles.cover}>
    <span className={styles.label}>{t('common.loading')}</span>
    <Spinner size={30} isLoading />
  </div>
);

export default AppLoader;
